<template>
  <article v-if="entries.length" class="w-full">
    <!-- speed 400: this one replaced a vue-glide slider, whose default animationDuration was 400ms (the
         slick-based sliders elsewhere ran at slick's own 500ms default). Swiper defaults to 300. -->
    <Swiper :slides-per-view="1" :speed="400" :breakpoints="breakpoints" :space-between="gap" class="w-full" @swiper="onSwiperInit" @slide-change="onSlideChange">
      <SwiperSlide v-for="(slide, index) in entries" :key="index" class="flex h-auto">
        <slot name="slide" :slide="slide"><!--a simple fallback here--></slot>
      </SwiperSlide>
    </Swiper>
    <div class="flex flex-row justify-center items-center mb-0">
      <button data-glide-dir="<" @click="swiper?.slidePrev()">
        <AtomIconArrowLeft class="w-4 h-4" :class="{ 'text-app-primary-1-red--torch': !color, 'text-app-secondary-9-blue--turquoise': color === 'blue' }" />
      </button>
      <div class="inline-flex ml-10 mr-10">
        <template v-for="index in entries.length" :key="index">
          <span
            class="tab"
            :class="{
              active: currentSlide + 1 === index,
              'bg-app-primary-1-red--torch': currentSlide + 1 === index && !color,
              'bg-app-secondary-9-blue--turquoise': currentSlide + 1 === index && color === 'blue',
              'bg-app-primary-grey--concrete': currentSlide + 1 !== index,
            }"
          ></span>
        </template>
      </div>
      <button data-glide-dir=">" @click="swiper?.slideNext()">
        <AtomIconArrowRight class="w-4 h-4" :class="{ 'text-app-primary-1-red--torch': !color, 'text-app-secondary-9-blue--turquoise': color === 'blue' }" />
      </button>
    </div>
  </article>
</template>

<script setup lang="ts">
import type { Swiper as SwiperClass } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'
import breakpointsList from '~/config/carousel'

defineProps({
  entries: { type: Array as PropType<any[]>, required: false, default: () => [] },
  breakpoints: { type: Object as PropType<Record<string, any>>, required: false, default: () => breakpointsList.mx3 }, // settings for the mx1, mx2, mx3, mx4 options can be found in carousel.js
  color: { type: String, required: false, default: undefined },
  gap: { type: Number, required: false, default: 32 },
})

const swiper = ref<SwiperClass | null>(null)
const currentSlide = ref(0)

function onSwiperInit(swiperInstance: SwiperClass) {
  swiper.value = swiperInstance
}
function onSlideChange(swiperInstance: SwiperClass) {
  currentSlide.value = swiperInstance.activeIndex
}
</script>

<style lang="scss">
.tab {
  @apply mx-px;
  width: theme('spacing.3');
  height: 2px;

  @screen md {
    width: theme('spacing.4');
    height: 3px;
  }
}
</style>
